import { ReactNode, useEffect, useState } from "react";

const DEFAULT_RENDERING_DELAY_MS = 1000;

type VirtualizedGridItemProps = {
  renderingDelay?: number;
  placeholder: ReactNode;
  component: ReactNode;
};

const VirtualizedGridItem = ({
  renderingDelay = DEFAULT_RENDERING_DELAY_MS,
  placeholder,
  component,
}: VirtualizedGridItemProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, renderingDelay);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return placeholder;
  }

  return component;
};

export default VirtualizedGridItem;
